/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'confluence-analytics-chart.default-loading-text': '分析データを更新中...',
  'confluence-analytics-chart.tooltip.no-views-data': 'データなし',
  'confluence-analytics-chart.tooltip.views-overall': '{count, plural, other {{count} 回のビュー}}',
  'confluence-analytics-chart.tooltip.views-today-so-far': '{count, plural, other {本日 {count} 回のビュー}}',
  'confuence-analytics-chart.accessible-table.caption': 'ページ ビュー',
  'confuence-analytics-chart.accessible-table.header.date': '日付',
  'confuence-analytics-chart.accessible-table.header.view-count': 'ビュー',
  'confuence-analytics-chart.accessible-table.no-view-count-data': 'ビューなし',
};
